/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, func } from 'prop-types'
import { jsx, Flex } from 'theme-ui'
import './formInputs.css'
import { ChevronDown } from '../../../icons/index'

const SelectFieldWithoutFormik = ({ onChange, id, ...props }) => {
  return (
    <Flex sx={{ flexDirection: 'column', width: '100%', maxWidth: 323, mt: 5 }}>
      <Flex>
        <Flex sx={{ position: 'relative', width: '100%' }}>
          <select
            id={id}
            onChange={e => onChange(e.target.value)}
            {...props}
            sx={{
              variant: 'forms.select',
            }}
          />
          <ChevronDown
            data-automation-id="chevron-select-icon"
            color="paleSilver"
            sx={{
              position: 'absolute',
              top: '22px',
              right: '20px',
              pointerEvents: 'none',
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

SelectFieldWithoutFormik.propTypes = {
  onChange: func,
  multiple: bool,
  label: string.isRequired,
  name: string.isRequired,
  id: string.isRequired,
}

export default SelectFieldWithoutFormik
